const COOKIES = {
    LOCALE: 'NEXT_LOCALE',
    ACCEPT_COOKIES: 'ACCEPT_COOKIES',
    CLIENT_ID: 'CLIENT_ID',
}

Object.freeze(COOKIES)

export default COOKIES
